export type PasswordStrength = {
  score: 0 | 1 | 2 | 3 | 4;
  label: "tooShort" | "weak" | "fair" | "good" | "strong";
};

export function scorePassword(pw: string): PasswordStrength {
  if (!pw || pw.length < 8) return { score: 0, label: "tooShort" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) score++;
  const s = Math.min(4, score) as 0 | 1 | 2 | 3 | 4;
  const labels = ["weak", "weak", "fair", "good", "strong"] as const;
  return { score: s, label: labels[s] };
}
